import React, { ReactNode, useEffect, useState } from "react";
import { useMatch } from "react-router-dom";
import AdvisorSidebar from "./AdvisorSidebar";
import MobileNav from "../MobileNav";
import { useAuth } from "../../contexts/AuthContext";
import advisorClientService from "../../services/advisorClientService";

interface AdvisorLayoutProps {
  children: ReactNode;
}

const AdvisorLayout: React.FC<AdvisorLayoutProps> = ({ children }) => {
  const { user } = useAuth();
  const [ibkrAccountId, setIbkrAccountId] = useState<string | null>(null);

  const clientsMatch = useMatch("/advisor/:advisorAccountId/clients");
  const groupsMatch = useMatch("/advisor/:advisorAccountId/groups");
  const groupDetailMatch = useMatch("/advisor/:advisorAccountId/groups/:groupId");
  const advisorAccountIdRaw =
    clientsMatch?.params.advisorAccountId ||
    groupsMatch?.params.advisorAccountId ||
    groupDetailMatch?.params.advisorAccountId ||
    null;

  const userRoles = user?.userRoles?.map((ur: { role: string }) => ur.role) || [];
  const hasAdvisorRole = userRoles.includes("ADVISOR");

  useEffect(() => {
    if (!advisorAccountIdRaw) return;

    if (hasAdvisorRole) {
      advisorClientService.listClients()
        .then(({ advisorIbkrAccountId }) => {
          if (advisorIbkrAccountId) setIbkrAccountId(advisorIbkrAccountId);
        })
        .catch(() => {});
    } else {
      advisorClientService.listClientsAdmin(Number(advisorAccountIdRaw))
        .then(({ advisorIbkrAccountId }) => {
          if (advisorIbkrAccountId) setIbkrAccountId(advisorIbkrAccountId);
        })
        .catch(() => {});
    }
  }, [hasAdvisorRole, advisorAccountIdRaw]);

  return (
    <div className="h-dvh bg-rp-black flex flex-col md:flex-row overflow-hidden">
      <MobileNav mode="advisor" />
      <AdvisorSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="h-16 border-b border-rp-separator flex items-center justify-between px-6 bg-rp-black/80 backdrop-blur shrink-0">
          <div className="flex items-center gap-4">
            <h2 className="text-lg font-bold text-rp-grey">Advisor Portal</h2>
            {ibkrAccountId && (
              <code className="text-xs font-mono text-gray-500 bg-rp-surface-raised px-2 py-0.5 rounded border border-rp-separator">
                {ibkrAccountId}
              </code>
            )}
          </div>
        </header>

        {/* Content */}
        <div className="flex-1 overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AdvisorLayout;
